import { render, staticRenderFns } from "./DrawerMenu.vue?vue&type=template&id=3b81289a&scoped=true&"
import script from "./DrawerMenu.vue?vue&type=script&lang=js&"
export * from "./DrawerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b81289a",
  null
  
)

export default component.exports